/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Submit_Translation_JobInputs */



/**
* | output |
* | --- |
* | "Submit {count} Translation Job" |
*
* @param {Submit_Translation_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const submit_translation_job = /** @type {((inputs: Submit_Translation_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submit_Translation_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Soumettre ${i?.count} traduction`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Übersetzungsauftrag ${i?.count} einreichen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Invia lavoro di traduzione ${i?.count}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Отправить задание на перевод ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Enviar trabajo de traducción ${i?.count}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`提交 ${i?.count} 翻译任务`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 翻訳ジョブを送信`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} अनुवाद कार्य जमा करें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Enviar trabalho de tradução ${i?.count}`)
	return /** @type {LocalizedString} */ (`Submit ${i?.count} Translation Job`)
});